import actionCreatorFactory from 'typescript-fsa';
// actionのprefixを設定
const actionCreator = actionCreatorFactory('loading');

const loading = actionCreator.async('LOADING');

export { loading };



// WEBPACK FOOTER //
// ./src/redux/modules/loading/actions.ts